import React from 'react';

import { Grid, Skeleton, Typography } from '@mui/material';

import { formatMoney } from '@clearverify/utils';

import { Field, SelectField } from 'src/components/finalForm';
import { VerificationRequestCreateFormFields } from 'src/constants/verificationRequest';
import { useStripeCustomerPaymentMethods } from 'src/hooks/stripe';
import { useCurrentUserVerifierStaff } from 'src/hooks/verifierStaff';
import type { SelectFieldOption } from 'src/types/components';

interface PaymentBlockProps {
  totalCharge: number;
  isReverification: boolean;
  loading: boolean;
  submitting: boolean;
}

export const PaymentBlock: React.FC<PaymentBlockProps> = props => {
  const { isReverification, loading, totalCharge, submitting } = props;

  const { verifierStaff } = useCurrentUserVerifierStaff();

  const { paymentMethods, loadingPaymentMethods, defaultPaymentMethodId } =
    useStripeCustomerPaymentMethods(verifierStaff?.stripeCustomerId);

  const paymentMethodOptions = React.useMemo(
    (): SelectFieldOption[] =>
      paymentMethods.map(paymentMethod => ({
        label: `**** ${paymentMethod.card?.last4 || paymentMethod.us_bank_account?.last4}`,
        value: paymentMethod.id,
      })),
    [paymentMethods],
  );

  return (
    <Grid container spacing={2} mt={2}>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Typography variant="body2" fontSize={20} fontWeight={500}>
          {loading ? (
            <React.Fragment>Loading...</React.Fragment>
          ) : (
            <React.Fragment>Total charge: {formatMoney(totalCharge)}</React.Fragment>
          )}
        </Typography>

        {isReverification && (
          <Typography variant="body2" fontSize={14}>
            This request is a Reverification.
          </Typography>
        )}
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        {loadingPaymentMethods ? (
          <Skeleton width="100%" height={60} />
        ) : (
          <Field
            name={VerificationRequestCreateFormFields.paymentMethod}
            component={SelectField}
            label="Payment method"
            options={paymentMethodOptions}
            fullWidth
            disabled={submitting}
            required
            initialValue={defaultPaymentMethodId}
          />
        )}
      </Grid>
    </Grid>
  );
};
